import { IBeneficiary, IBeneficiaryResourceDocument, IDependent } from 'src/shared/types/Beneficiary';
import { ImsAxiosInstance } from '../axios/axios';

export const getBeneficiaryResourceDocument = async (caseId: number): Promise<IBeneficiaryResourceDocument[]> => {
  const response = await ImsAxiosInstance.get(`api/BeneficiaryResourceDocument?caseId=${caseId}`);
  return response.data;
};

export const getBeneficiary = async (beneId: number): Promise<IBeneficiary> => {
  const response = await ImsAxiosInstance.get(`api/beneficiariesList/${beneId}`);
  return response.data;
};

export const getDependents = async (beneId: number): Promise<IDependent[]> => {
  const response = await ImsAxiosInstance.get(`api/dependents?beneId=${beneId}`);
  return response.data;
};

export const checkHasActiveUsCase = async (beneId: number): Promise<boolean> => {
  const response = await ImsAxiosInstance.get(`api/Beneficiary/HasActiveUsCase?beneId=${beneId}`);
  return response.data;
};
